module.exports = __webpack_public_path__ + "static/media/home-illustration.e7bcc0b4.jpg";